/** @format */

export const currencyFormat = number => {
  return Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(number);
};
export const numberFormat = number => {
  return Intl.NumberFormat('de-DE').format(number);
};
